import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { phieuChamDiemNCCApi } from "src/1/apis/phieu_cham_diem_nha_cung_cap.api";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { FormTable, FormToolbar } from "../../components";

const PhieuChamDiemNhaCungCap = () => {
  //#region Data
  const params = useParams();

  const [formId, setFormId] = useState(params?.id ?? "");
  const [mode, setMode] = useState("form"); // "form" | "supplier" | "rating"

  const { data, refetch } = useQuery({
    queryKey: ["chi-tiet-phieu-cham-diem-nha-cung-cap", formId],
    queryFn: () => phieuChamDiemNCCApi.getById(formId),
    enabled: !!formId,
    select: (response) => response?.data?.data,
  });

  const isMobile = useMobileDevice();
  //#endregion

  //#region Render
  return (
    <>
      <CCard className={classNames("toolbar", !isMobile && "sticky")}>
        <CCardBody>
          <FormToolbar
            editData={data}
            mode={mode}
            setMode={setMode}
            setId={setFormId}
          />
        </CCardBody>
      </CCard>

      {data && (
        <CCard>
          <CCardBody className="px-0 pt-4">
            <FormTable
              formId={data?.id}
              suppliers={data?.suppliers || []}
              mode={mode}
              setMode={setMode}
              refetch={refetch}
            />
          </CCardBody>
        </CCard>
      )}
    </>
  );
  //#endregion
};
export default PhieuChamDiemNhaCungCap;
